import { render, staticRenderFns } from "./notifyDingTalkList.vue?vue&type=template&id=1384eb74&scoped=true"
import script from "./notifyDingTalkList.vue?vue&type=script&lang=js"
export * from "./notifyDingTalkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1384eb74",
  null
  
)

export default component.exports